import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';
import ACF from '../../../../assets/background/ngo/spa.webp';
import PU from '../../../../assets/background/ngo/forest.webp';
import UEPM from '../../../../assets/background/ngo/child.webp';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    },
    container: {
      height: '100%',
      maxHeight: '250px',
      '& > div': {
        height: '100%',
        maxHeight: '250px'
      },
      '@media (max-width: 425px)': {
        '& > div': {
          height: 'auto',
          maxHeight: '100%'
        },
        height: 'auto',
        maxHeight: '100%'
      }
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    tableResult: {
      margin: '0',
      color: palette.text.white,
      fontWeight: 700,
      display: 'flex',
      gap: '10px'
    },
    title: {
      display: 'flex',
      gap: '10px',
      alignItems: 'flex-start',
      '& h2': {
        fontSize: '1rem',
        fontFamily: 'Montserrat'
      }
    },
    textButtonContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      gap: '20px'
    },
    emoji: {
      width: '20px'
    },

    itemTitle: {
      position: 'absolute',
      top: '10px',
      left: 0,
      display: 'flex',
      justifyContent: 'center',
      width: '100%'
    },
    item: {
      width: '50px'
    },
    ngoItemContainer: {
      position: 'relative',
      borderRadius: palette.borderRadius.default,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '10px',
      height: '100%',
      maxHeight: '250px',
      backgroundSize: 'cover',
      color: 'white',
      boxShadow: palette.shadows.boxShadow,
      '@media (max-width: 1280px)': {
        padding: '10px'
      },
      '@media (max-width: 425px)': {
        height: 'auto',
        maxHeight: '100%'
      }
    },
    Planete_urgence: {
      background: `linear-gradient(180deg, rgb(0, 0, 0, 0.5) 0%, rgb(0, 0, 0, 0) 100%), url(${PU})`,
      backgroundSize: 'cover',
      color: 'white',
      backgroundPosition: 'center'
    },
    Un_enfant_par_la_main: {
      background: `linear-gradient(180deg, rgb(0, 0, 0, 0.5) 0%, rgb(0, 0, 0, 0) 100%), url(${UEPM})`,
      backgroundSize: 'cover',
      color: 'white',
      backgroundPosition: 'center'
    },
    Societe_protectrice_des_animaux: {
      background: `linear-gradient(180deg, rgb(0, 0, 0, 0.5) 0%, rgb(0, 0, 0, 0) 100%), url(${ACF})`,
      backgroundSize: 'cover',
      color: 'white',
      backgroundPosition: 'center'
    },
    slogan: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      textAlign: 'center'
    },
    numberOfItems: {
      fontSize: '2rem',
      fontWeight: 'bold',
      backgroundColor: 'white',
      padding: '10px 20px',
      borderRadius: palette.borderRadius.default,
      color: 'green',
      mixBlendMode: 'luminosity',
      width: 'fit-content',
      height: 'fit-content'
    },
    recapItems: {
      fontSize: '1.25rem',
      textTransform: 'uppercase'
    },
    itemsContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      justifyContent: 'center',
      alignItems: 'center',
      height: 'initial',
      '@media (max-width: 1280px)': {
        flexDirection: 'row'
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
